<script setup>
// import {computed} from "vue";

// const isAuthPage = computed(() => authRoutes.includes(route.name));

</script>

<template>
  <div class="auth-layout">
    <slot />
  </div>
</template>

<style scoped>

</style>